var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerfilActivo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#002EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.06294 13.7888C4.39849 11.9189 6.03349 10.5 7.9999 10.5C9.9663 10.5 11.6013 11.9189 11.9369 13.7888C12.2428 13.5803 12.5313 13.3482 12.7998 13.0952C12.3876 11.6842 11.37 10.5315 10.0473 9.93704C11.2167 9.23893 11.9999 7.96093 11.9999 6.5C11.9999 4.29086 10.209 2.5 7.9999 2.5C5.79076 2.5 3.9999 4.29086 3.9999 6.5C3.9999 7.96093 4.7831 9.23893 5.95253 9.93704C4.62976 10.5315 3.61223 11.6842 3.19995 13.0952C3.46848 13.3482 3.75702 13.5803 4.06294 13.7888ZM7.9999 9.5C9.65675 9.5 10.9999 8.15685 10.9999 6.5C10.9999 4.84315 9.65675 3.5 7.9999 3.5C6.34304 3.5 4.9999 4.84315 4.9999 6.5C4.9999 8.15685 6.34304 9.5 7.9999 9.5Z",
    fill: "#002EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfilActivo);
export default __webpack_public_path__ + "static/media/perfil-activo.607409f4a7a6e045c9dc55d937eec042.svg";
export { ForwardRef as ReactComponent };